import React, { Component } from 'react';
import { Row, Col, Panel, Button } from 'react-bootstrap';
import Logo from 'src/js/HeaderLogo';
import Cognito from 'src/js/Cognito';

class ErrorBoundary extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null, errorInfo: null,
        }

        this.signOut = this.signOut.bind(this);
    }

    componentDidCatch(error, errorInfo) {
        console.log(error);
        this.setState({
            error: error,
            errorInfo: errorInfo
        })
    }

    signOut() {
        Cognito.signOut();
        window.location.href = '/login';
    }

    render() {

        if (this.state.errorInfo) {
            return (
                <div>
                    <div className='mainContents'>
                        <Row>
                            <div className="mini-div" />
                            <Logo />
                            <Col md={12} sm={12} xs={12}>
                                <Panel className="app-error-panel center-block">
                                    <h2>ApplicationError</h2>
                                    <hr />
                                    <section>
                                        <h3>Error</h3>
                                        <p>{this.state.error && this.state.error.toString()}</p>
                                    </section>
                                    <section>
                                        <h3>ErrorMessage</h3>
                                        <p>{this.state.error && this.state.error.message}</p>
                                    </section>
                                    <div className="mini-div" />
                                    <Button className="pull-right" onClick={this.signOut}>Go back to login page</Button>
                                </Panel>
                            </Col>
                        </Row>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/js/ErrorBoundary.js